import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { PHP_BACK, getUser, PHP_API } from "../../../utils/Common";
import MyLoader from "../../sharecomponents/MyLoader";
import { generarExcel } from "../../sharecomponents/ExcelUtilities";
import VainillaDialog from "../../sharecomponents/vanilladialog";
import { getWeekNumber } from "../../../utils/Common";
import EjecucionSiembraPDF from "../../templates/EjecucionSiembraPDF";
import Verifiers from "../../../utils/Verifiers";

const RpteSiembraSemanal = (props) => {
    const weekinfo = getWeekNumber();
    const [semanaSel, setsemanaSel] = useState((`${weekinfo[0]}`).substring(2, 4) + weekinfo[1]);
    const [planes, setPlanes] = useState([]);
    const [loader, updateLoader] = useState(false);
    const [dialog, setDialog] = useState({ show: false });
    const [showSave, setShowSave] = useState(false);
    const [historial, setHistorial] = useState([]);
    const [semanas, setsemanas] = useState([]);
    const [todosLosRegistros, settodosLosRegistros] = useState(false);
    const user = getUser();
    const thClass = "text-center text-m border nowrap";
    const tdClass = "border text-center text-m m-0 p-1 nowrap";
    const dias = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
    const [totales, settotales] = useState({ charolas: 0, plantas: 0, ejecutadocharolas: 0, ejecutadoplantas: 0, plancharolas: 0, planplantas: 0 });
    const totales_keys = [{ key: '', name: 'PLAN DE SIEMBRA', color: "text-blue-900 bg-blue-100 border-blue-400" },
    { key: 'plan', name: 'PLANEADO', color: "text-red-900 bg-red-100 border-red-400" },
    { key: 'ejecutado', name: 'EJECUTADO', color: "text-green-900 bg-green-100 border-green-400" }];
    const [pdf, setpdf] = useState(false);
    const [screen, setscreen] = useState({ width: window.innerWidth, height: window.innerHeight });
    /*const [screen, setscreen] = useState({ width: window.innerWidth, height: window.innerHeight });Verifiers.onScreenResize(setscreen);maxHeight: Verifiers.maxHeight(screen, 780, 1200, 68, .1)
   */

    useEffect(() => {
        getPlanes((`${weekinfo[0]}`).substring(2, 4) + weekinfo[1]);
        Verifiers.onScreenResize(setscreen);
    }, []);

    const alternarModo = () => {
        let modo = !todosLosRegistros;
        settodosLosRegistros(modo);
        getPlanes(semanaSel, modo);
    }

    const getPlanes = (p = semanaSel, todos = todosLosRegistros) => {
        updateLoader(true);
        axios.post(PHP_BACK + 'api/getPlanesPendientes', { semana: p, todos: todos })
            .then(r => {
                if (r.data) {
                    setPlanes(r.data.reportes ?? []);
                    setsemanas(r.data.semanas);
                    settotales(r.data.totales);
                }
                updateLoader(false);
            })
            .catch(e => console.log(e));
    }

    const cambiar = (dia, cantidad, planID, index) => {
        let cantHist = numberFormat(cantidad);

        historial.push({ planId: planID, dia: dia, cantidad: cantHist });
        setHistorial([...historial]);

        let campo = dia.toLowerCase() + '_ejecutado';
        let pl = { ...planes };
        pl[index][campo] = cantidad;

        pl[index] = recalcularTotalEjecutado(pl[index]);
        setPlanes([...planes]);
        setShowSave(true);
    }
    const recalcularTotalEjecutado = (plan) => {
        let total = 0;
        let dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
        for (let i = 0; i < dias.length; i++) {
            let campo = dias[i] + '_ejecutado';
            let valor = numberFormat(plan[campo]);
            total += valor;
        }
        plan.total_ejecutado = total;
        return plan;
    }

    const guardarCambios = () => {
        updateLoader(true);
        let dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];

        for (let i = 0; i < planes.length; i++) {
            for (let j = 0; j < dias.length; j++) {
                let campo = dias[j] + '_ejecutado';
                if (typeof planes[i][campo] == 'string') {
                    let val = parseFloat(planes[i][campo]);
                    if (isNaN(val)) planes[i][campo] = 0;
                    else planes[i][campo] = val;
                }
            }
        }

        axios.post(PHP_API + 'reporteCantidadEjecucionSemanal',
            { planes: planes, historial: historial, userID: user.id, nombre: user.nombre })
            .then(r => {
                updateLoader(false);
                if (r.data.success) {
                    getPlanes();
                    setHistorial([]);
                    setDialog({ show: false });
                    setShowSave(false);
                } else {
                    setDialog({
                        show: true,
                        tipo: 'error',
                        title: 'NO FUE POSIBLE GUARDAR CAMBIOS',
                        body: 'Ocurrió un error y no fue posible guardar uno o más de los cambios solicitados',
                        respYes: 'Aceptar',
                        size: 's',
                        funct: (resp) => { setDialog({ show: false }); }
                    });
                }

            })
            .catch(e => { updateLoader(false); setDialog({ show: false }); });
    }

    const preguntarGuardar = () => {
        setDialog({
            show: true,
            tipo: 'success',
            title: '¿Guardar cambios?',
            body: '¿Aplicar los cambios realizados a los registros del sistema?',
            respYes: 'Si guardar cambios',
            respNot: 'No, volver sin guardar',
            size: 's',
            funct: (resp) => {
                if (resp) guardarCambios();
                else setDialog({ show: false });
            }
        });
    }

    const changeWeek = (e) => {
        setsemanaSel(e.target.value);
        getPlanes(`${e.target.value}`);
    }

    /**
   * @returns {JSX.Element} - Retorna un renglon con la sumatoria de las columnas de la tabla de planes de siembra
   */
    const renglonSumatoriaDeColumnas = () => {
        let diasNombres = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
        let diasNombresLen = diasNombres.length;
        let planesLen = planes.length;

        let resultados = {
            total_plan: 0,
            total_ejecutado: 0,
            charolas: 0,
            plantas: 0,
        };

        for (let i = 0; i < diasNombresLen; i++) {
            let keyPlan = diasNombres[i] + '_plan';
            let keyEjecutado = diasNombres[i] + '_ejecutado';
            resultados[keyPlan] = 0;
            resultados[keyEjecutado] = 0;
        }

        for (let i = 0; i < planesLen; i++) {
            let plan = planes[i];
            for (let j = 0; j < diasNombresLen; j++) {
                let keyPlan = diasNombres[j] + '_plan';
                let keyEjecutado = diasNombres[j] + '_ejecutado';
                resultados[keyPlan] += Verifiers.numberParser(plan[keyPlan], 0);
                resultados[keyEjecutado] += Verifiers.numberParser(plan[keyEjecutado], 0);
            }
            resultados.charolas += Verifiers.numberParser(plan.charolas, 0);
            resultados.plantas += Verifiers.numberParser(plan.plantas, 0);
        }

        for (let i = 0; i < diasNombresLen; i++) {
            let keyPlan = diasNombres[i] + '_plan';
            let keyEjecutado = diasNombres[i] + '_ejecutado';
            resultados.total_plan += resultados[keyPlan];
            resultados.total_ejecutado += resultados[keyEjecutado];
        }

        return (
            <tr className="bg-white dosis text-bold text-m">
                <td className="border text-left text-m "></td>
                <td className="border text-center text-m nowrap text-bold text-l pt-3 bg-white">Totales</td>
                <td className="border text-center text-m pt-3 bg-white nowrap" style={{ width: "150px" }}></td>
                <td className="border text-center nowrap text-m pt-3 bg-white">
                    {Math.floor(resultados.plantas, 0)}<span className="ms-2 me-2 text-900">|</span>{Math.ceil(resultados.charolas, 0)}
                </td>
                <td className='text-center text-bold bw-200 pt-3 bg-white'>
                    <div className='row justify-content-evenly w-100 p-0 m-0'>
                        <div className='col-auto m-0 p-0'>{Math.ceil(resultados.total_plan)}</div>
                        <div className='col-auto mt-0 mb-0 ms-1 me-1 text-bold p-0'>|</div>
                        <div className='col-auto m-0 p-0'>{Math.ceil(resultados.total_ejecutado)}</div>
                    </div>
                </td>
                {
                    diasNombres.map((dia, j) => {
                        let keyPlan = dia + '_plan';
                        let keyEjecutado = dia + '_ejecutado';
                        return (
                            <td className="border text-center text-m  pt-3 bg-white" key={'dia sdsect' + j}>
                                <div className='row justify-content-evenly w-100 p-0 m-0'>
                                    <div className='col-auto m-0 p-0'>{Math.ceil(resultados[keyPlan])}</div>
                                    <div className='col-auto mt-0 mb-0 ms-1 me-1 text-bold p-0'>|</div>
                                    <div className='col-auto m-0 p-0'>{Math.ceil(resultados[keyEjecutado])}</div>
                                </div>
                            </td>
                        )
                    })
                }
            </tr>
        )

    }

    const numberFormat = (number) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return 0;
            return format;
        } catch (error) {
            return 0;
        }
    }

    return (
        <div className="w-full p-0 text-start bg-white round-top-m shadow dosis">
            <div className="row justify-content-center border-b rounded-t p-2 round-top-m m-0 bg-orange-900">
                <div className='col-lg-12 m-0 p-0'>
                    <p className="h4 text-white m-0 p-0">Ejecución de siembra por día de la semana<span className="text-s text-300 text-white ms-3">Ingrese las cantidades que sembraron VS las cantidades planeadas</span></p>
                </div>
            </div>
            <div className="row justify-content-evenly border-b rounded-t m-0 p-0 bg-white w-100">
                <div className='col-auto contenedor'>
                    <button className='w-100 round-xxl btn btn-sm btn-light shadow-sm border borer-3' onClick={alternarModo}>
                        {todosLosRegistros ? 'Todos los registros' : 'Registros faltantes'}
                    </button>
                </div>
                <select className='bw-100 m-1 form-control form-control-sm shadow-smtext-bold border shadow border border-2' value={semanaSel} onChange={changeWeek} style={{ overflow: 'auto' }}>
                    <option value={""} className="text-s" >Elegir semana</option>
                    {
                        semanas.map((semana, i) => {
                            return (<option value={semana.semana} key={"semsana" + i}>{semana.semana}</option>)
                        })
                    }

                </select>
                <div className='col-auto conteneor'>
                    {showSave && <button className='bw-150 pt-0 pb-0 btn btn-sm btn-dark shadow dosis text-s scale-continue-05  m-1' style={{ width: '150px' }} onClick={preguntarGuardar}>Guardar cambios</button>}
                </div>



                {
                    totales_keys.map((dt, i) => {
                        let pl = dt.key + "plantas", ch = dt.key + "charolas";
                        return (
                            <div key={"totales" + i} className={`text-center round-m m-1 col-auto nowrap text-s p-0 ps-1 pe-2 contenedor border ${dt.color}`} >
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className="w-100 m-0 p-0">{dt.name}
                                        <span className="text-s ms-2 text-bold"> {totales[pl]} pl <span className="text-dark ms-1 me-1 text-bold">-</span>{totales[ch]} ch</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

                <div className="m-0 contenedor col-auto" >
                    <button className='btn btn-sm scale-05 m-0 ps-4 pe-4 btn-success shadow text-bold round-s' onClick={() => {
                        if (planes.length === 0) return;
                        let dt = [];
                        for (let i = 0; i < planes.length; i++) {
                            let p = planes[i];
                            let reg = {
                                'SEMANA SIEMBRA': p.semana_siembra,
                                'TRASPLANTE': p.transplante,
                                FLOR: `${p.flor} ${p.variedad} ${p.color}`,
                                SEMBRAR: p.charolas,
                                PLANTAS: p.plantas,
                                'TOTAL PLANEADO': numberFormat(p.total_planeado).toFixed(0),
                                'TOTAL EJECUTADO': numberFormat(p.total_ejecutado).toFixed(0)
                            };
                            dias.forEach(dia => {
                                reg[dia.toUpperCase() + " PLANEADO"] = p[dia.toLowerCase() + "_plan"];
                                reg[dia.toUpperCase() + " EJECUTADO"] = p[dia.toLowerCase() + "_ejecutado"];
                            });
                            dt.push(reg);
                        }
                        generarExcel(dt, 'REPORTE EJECUCIÓN SIEMBRA')
                    }}>Excel</button>
                </div>

                <div className="m-0 contenedor col-auto" >
                    <button className='btn btn-sm scale-05 m-0 ps-4 pe-4 btn-danger border border-dark border-1 shadow text-bold round-s'
                        onClick={() => { if (!pdf && planes.length > 0) setpdf(true); }}>PDF</button>
                </div>

                <div className='w-100 p-0 mt-2'></div>
                <div className="p-0 m-0 bg-light" style={{ overflow: 'auto', height: Verifiers.maxHeight(screen, 700, 1200, 80.5, .3), width: '100%' }}>
                    <table className="table table-sm table-bordered  table-hover">
                        <thead>
                            <tr>
                                {/*<th className="text-center text-s">Acciones</th>*/}
                                <th className={thClass}>S. siembra</th>
                                <th className="text-center text-m border nowrap">Flor variedad color</th>
                                <th className="text-center border nowrap text-s" >S. ejecución</th>
                                <th className="text-center text-m border nowrap m-0 p-0">
                                    <div className='w-100 m-0 p-0 text-m text-center'>Plan de siembra</div>
                                    <div className='w-100 m-0 p-0 text-xs text-center'>Plantas<span className="ms-2 me-2 text-900">|</span>charolas</div>
                                </th>

                                <th className="text-center text-m border text-bold nowrap">
                                    <div className='w-100 m-0 p-0 text-xs'>Sumatoria (charolas)</div>
                                    Planeado<span className="ms-2 me-2 text-900">|</span>Ejecutado

                                </th>
                                {dias.map((d, i) => <th key={d + i} className="text-center text-m border border-orange-900 px-2 py-1">
                                    <div className='w-100 m-0 p-0'>{d}</div>
                                    <div className='w-100 m-0 p-0 text-xs text-center'>
                                        Planeado<span className="ms-2 me-2 text-900">|</span>Ejecutado
                                    </div>
                                </th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                planes.map((p, i) => {
                                    return (
                                        <tr key={i + 'fffdd' + p.id} className="border">
                                            <td className={tdClass + (Verifiers.diferencia(p) !== 0 ? ' rosa-retrasado' : '')} >{p.semanainicio}</td>

                                            <td className={tdClass + " text-600 " + (Verifiers.diferencia(p) !== 0 ? 'rosa-retrasado' : '')}>{p.flor} {p.variedad} {p.color}</td>
                                            <td className={"border text-left text-s text-center " + (Verifiers.diferencia(p) !== 0 ? 'rosa-retrasado' : '')}><span>{p.semana_ejecucion ?? '-'}</span></td>
                                            <td className=" text-300 bw-200 text-s text-center">
                                                {p.plantas}<span className="text-dark ms-2 me-2 text-bold">|</span>{Math.round(p.charolas)}
                                            </td>

                                            <td className='text-center text-400'
                                                style={{ backgroundColor: p.total_planeado <= p.total_ejecutado ? "rgba(155, 255, 181,.4)" : "rgba(155, 255, 181,0)" }}
                                            >
                                                {numberFormat(p.total_planeado).toFixed(0)}<span className="text-dark ms-2 me-2 text-bold">|</span>{numberFormat(p.total_ejecutado).toFixed(0)}
                                            </td>
                                            {
                                                dias.map((dia, j) => {
                                                    return (
                                                        <td className="border text-center text-m p-0 m-0" key={i + 'dia sect' + j} style={{ minWidth: '140px', maxWidth: '140px' }}>
                                                            <div className='row justify-content-evenly text-m p-0 m-0 w-100'>
                                                                <div className={`text-s contenedor m-0 p-0 ${Verifiers.numberParser(p[dia.toLowerCase() + "_plan"], 0) === 0 ? '' : 'text-bold'}`} style={{ maxWidth: '65px' }}>{numberFormat(p[`${dia.toLowerCase()}_plan`]).toFixed(0)} </div>
                                                                <div className='m-0 p-0 ' style={{ maxWidth: '65px' }}>
                                                                    <input type='number' step="0.1" value={p[`${dia.toLowerCase()}_ejecutado`]}
                                                                        className={`form-control form-control-sm ${Verifiers.numberParser(p[dia.toLowerCase() + "_ejecutado"], 0) === 0 ? '' : 'text-bold'}`}
                                                                        onChange={(e) => cambiar(dia, e.target.value, p.id, i)} />
                                                                </div>


                                                            </div>
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                            {renglonSumatoriaDeColumnas()}
                        </tbody>
                    </table>
                </div>

                <VainillaDialog data={dialog} />
                {/*<ModalRpteSiembra ref={modalRef} fn={getPlanes} />*/}
                {pdf && <div className='vw-100 vh-100 m-0 p-0 bg-white3 blur-xl' style={{ position: "fixed", zIndex: 99, top: 0, left: 0, overflow: 'auto' }}>
                    <div className='row justify-content-evenly p-0 m-0 w-100'>
                        <EjecucionSiembraPDF data={planes} loader={updateLoader} close={() => { setpdf(false) }} />
                    </div>
                </div>}
                {loader && <MyLoader />}
            </div>
        </div>
    );
}

export default RpteSiembraSemanal;
